<div class="user-profile-main-container text">
  <div class="info-container">
    <div class="user-profile-dropdown-header" (click)="toggleDropDown(1)">
      <div class="header-left-side">{{ 'personal_information' | t }}</div>
      <div class="header-right-side">
        <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (personalInfoDropDownIsOpen ? 'up' : 'down')"></image-loader-utils>
      </div>
    </div>
    <div class="user-profile-content-container text" *ngIf="personalInfoDropDownIsOpen">
      <div class="user-content-row">
        <div class="user-content-row-left">{{ 'Title' | t }}</div>
        <div class="user-content-row-right"></div>
      </div>

      <div class="user-content-row">
        <div class="user-content-row-left">{{ 'First_Name' | t }}:</div>
        <div class="user-content-row-right">{{ this._UiHelper.userProfileList?.CustomerName }}</div>
      </div>
      <div class="user-content-row">
        <div class="user-content-row-left">{{ 'Last_Name' | t }}:</div>
        <div class="user-content-row-right">{{ this._UiHelper.userProfileList?.CustomerSurname }}</div>
      </div>
      <div class="user-content-row">
        <div class="user-content-row-left">{{ 'bday' | t }}:</div>
        <div class="user-content-row-right">{{ this._UiHelper.userProfileList?.Birthday }}</div>
      </div>
      <div class="user-content-row">
        <div class="user-content-row-left">{{ 'IBAN' | t }}</div>
        <div class="user-content-row-right">{{ this._UiHelper.userProfileList?.Language }}</div>
      </div>
      <div class="user-content-row">
        <div class="user-content-row-left">{{ 'Email' | t }}:</div>
        <div class="user-content-row-right">{{ this._UiHelper.userProfileList?.Email }}</div>
      </div>
      <div class="user-content-row">
        <div class="user-content-row-left">{{ 'Phone_Number' | t }}:</div>
        <div class="user-content-row-right">{{ this._UiHelper.userProfileList?.PhoneNumber }}</div>
      </div>
      <div class="user-content-row">
        <div class="user-content-row-left">{{ 'address' | t }}:</div>
        <div class="user-content-row-right">{{ this._UiHelper.userProfileList?.Address }}</div>
      </div>
      <div class="user-content-row">
        <div class="user-content-row-left">{{ 'post_code' | t }}:</div>
        <div class="user-content-row-right">{{ this._UiHelper.userProfileList?.ZipCode }}</div>
      </div>
      <div class="user-content-row">
        <div class="user-content-row-left">{{ 'City' | t }}:</div>
        <div class="user-content-row-right">{{ this._UiHelper.userProfileList?.City }}</div>
      </div>
      <div class="user-content-row">
        <div class="user-content-row-left">{{ 'country' | t }}:</div>
        <div class="user-content-row-right">{{ this._UiHelper.userProfileList?.Country }}</div>
      </div>
    </div>
  </div>
  <div class="info-container">
    <div class="user-profile-dropdown-header" (click)="toggleDropDown(2)">
      <div class="header-left-side">{{ 'ChangePassword' | t }}</div>
      <div class="header-right-side">
        <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (changePasswordDropDownIsOpen ? 'up' : 'down')"></image-loader-utils>
      </div>
    </div>
    <div class="change-password-content-container" *ngIf="changePasswordDropDownIsOpen">
      <change-password></change-password>
    </div>
  </div>
  <div class="info-container">
    <div class="user-profile-dropdown-header" (click)="toggleDropDown(3)">
      <div class="header-left-side">{{ 'Settings' | t }}</div>
      <div class="header-right-side">
        <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (settingsDropDownIsOpen ? 'up' : 'down')"></image-loader-utils>
      </div>
    </div>
    <div class="user-profile-content-container settings-container" *ngIf="settingsDropDownIsOpen">
      <ng-container *ngIf="'isDarkMode' | getEnv">
        <div class="settings-select-container">
          <div class="select-left-side">{{ 'b3000_Mode' | t }}</div>
          <div class="select-right-side">
            <div class="select-row">
              <div class="select-input">
                <input type="radio" id="mode" name="mode" value="mode" checked="{{ this._UiHelper.currentTheme === 'theme-light' ? 'checked' : '' }}" (click)="changeTheme('')" />
              </div>
              <div class="select-input-name">{{ 'b3000_Light' | t }}</div>
            </div>
            <div class="select-row">
              <div class="select-input">
                <input
                  type="radio"
                  id="mode"
                  name="mode"
                  value="mode"
                  checked="{{ this._UiHelper.currentTheme === 'theme-dark' ? 'checked' : '' }}"
                  (click)="changeTheme('dark')" />
              </div>
              <div class="select-input-name">{{ 'b3000_Dark' | t }}</div>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="settings-select-container">
        <div class="select-left-side">{{ 'b3000_Limit_time' | t }}</div>
        <div class="select-right-side">
          <div class="select-row">
            <div class="select-input">
              <input type="radio" id="limitTime" name="limitTime" value="limitTime" />
            </div>
            <div class="select-input-name">{{ 'b3000_None' | t }}</div>
          </div>
          <div class="select-row">
            <div class="select-input">
              <input type="radio" id="limitTime" name="limitTime" value="limitTime" checked />
            </div>
            <div class="select-input-name">12 {{ 'b3000_h' | t }}</div>
          </div>
          <div class="select-row">
            <div class="select-input">
              <input type="radio" id="limitTime" name="limitTime" value="limitTime" />
            </div>
            <div class="select-input-name">24 {{ 'b3000_h' | t }}</div>
          </div>
        </div>
      </div>
      <div class="settings-select-container">
        <div class="select-left-side">{{ 'b3000_Odds_Format' | t }}</div>
        <div class="select-right-side">
          <div class="select-row">
            <div class="select-input">
              <input type="radio" id="oddsFormat" name="oddsFormat" value="oddsFormat" checked />
            </div>
            <div class="select-input-name">{{ 'b3000_Decimal' | t }}</div>
          </div>
          <div class="select-row">
            <div class="select-input">
              <input type="radio" id="oddsFormat" name="oddsFormat" value="oddsFormat" />
            </div>
            <div class="select-input-name">{{ 'b3000_Fractional' | t }}</div>
          </div>
          <div class="select-row">
            <div class="select-input">
              <input type="radio" id="oddsFormat" name="oddsFormat" value="oddsFormat" />
            </div>
            <div class="select-input-name">{{ 'b3000_American' | t }}</div>
          </div>
        </div>
      </div>
      <div class="settings-select-container">
        <div class="select-left-side">{{ 'Language' | t }}</div>
        <div class="select-right-side">
          <div class="select-row">
            <div class="select-input select-input-full-width">
              <div class="selected-language" (click)="toggleDropDown(4)">
                <div class="selected-flag">
                  <image-loader-utils [url]="this.langDatas[this.selectedLang].ISOabbr" [isFlags]="true" extraClasses="flag-rounded"></image-loader-utils>
                </div>
                <div class="selected-lang-name">{{ this.langDatas[this.selectedLang].langNativeNames }}</div>
                <div class="right">
                  <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (langDropDownIsOpen ? 'up' : 'down')"></image-loader-utils>
                </div>
              </div>
              <ng-container *ngFor="let lang of langDatasArry">
                <div class="lang-dropdown-menu" *ngIf="langDropDownIsOpen">
                  <div class="lang-dropdown-item" (click)="selectionChange(lang.langCode)">
                    <div class="flag">
                      <image-loader-utils [url]="lang.ISOabbr" [isFlags]="true" extraClasses="flag-rounded"></image-loader-utils>
                    </div>
                    <div class="lang">
                      {{ lang.langNativeNames }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <ng-container [ngSwitch]="['b500'] | getProductName">
        <ng-container *ngSwitchCase="'b500'"></ng-container>
        <ng-container *ngSwitchDefault>
          <withdraw-auto></withdraw-auto>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
